import { render } from "./LogoTrk.vue?vue&type=template&id=5c169954&scoped=true"
const script = {}

import "./LogoTrk.vue?vue&type=style&index=0&id=5c169954&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-5c169954"

export default script